/**
 * Handles cancel event
 */
export const cancelHandler = () => async () => {
  return Promise.resolve();
};
